import React from 'react';
import { useTranslation } from 'react-i18next';
import { museoSection1 } from '../utils/museoContent';
import { museoSection1En } from '../utils/museoContentEn';
import { getRelatedSectionsForMuseo } from '../utils/relatedSections';
import RelatedSections from './RelatedSections';

const Museo1 = () => {
  const { t, i18n } = useTranslation();
  const content = i18n.language === 'en' ? museoSection1En : museoSection1;

  return (
    <div className='TesisPage TesisPage--museo'>
      <aside className='TesisPage-rail'>
        <RelatedSections items={getRelatedSectionsForMuseo('/Museo1')} />
      </aside>
      <h1 className='TesisPageTitle'>{t('museo1.title')}</h1>
      <h2 className='TesisPageSubtitle'>{t('museo1.subtitle')}</h2>
      <article className='TesisPageContent'>
        {content.map((p, i) => <p key={i}>{p}</p>)}
      </article>
    </div>
  );
};

export default Museo1;
